import { Component, Input } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/zh-cn';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { FormFlowInfo } from 'src/app/modules/shared/models/form/form-flow-info.model';
import {
  WorkFlowActionType,
  WorkFlowActionTypeMap,
} from 'src/app/modules/shared/models/form/work-flow-action-type.enum';
import { WorkFlowRefectSignRequest } from 'src/app/modules/shared/models/form/work-flow-refect-sign-request.model';
import { WorkFlowUserService } from 'src/app/modules/shared/services/work-flow-user.service';

@Component({
  selector: 'app-dialog-form-reject',
  templateUrl: './dialog-form-reject.component.html',
  styleUrls: ['./dialog-form-reject.component.scss'],
})
export class DialogFormRejectComponent {
  @Input()
  data!: DialogConfig<{
    options: { value: number; label: string }[];
    workFlowId: number;
    formFlows: FormFlowInfo[];
    isCancel: boolean;
    defaultFlowValue?: string;
  }>;

  submiting = false;

  fileOpts: { value: number; label: string }[] = [];

  flowOpts: { value: string; label: string }[] = [];

  selected: number[] = [];

  selectFlow: string = '';

  record: WorkFlowRefectSignRequest = new WorkFlowRefectSignRequest();

  isCancel: boolean = false;

  constructor(
    private message: NzMessageService,
    private workFlowUserService: WorkFlowUserService,
  ) {}

  ngOnInit() {
    this.record.workFlowId = this.data.data!.workFlowId;
    this.record.rejectReason = '';
    this.record.togetherWorkFlowIds = [];
    this.selected = [];
    this.fileOpts = this.data.data?.options ?? [];
    this.isCancel = this.data.data?.isCancel ?? false;
    if (this.data.data?.defaultFlowValue) {
      this.selectFlow = this.data.data.defaultFlowValue;
    }
    console.log(this.data.data?.formFlows);
    const flowOpts: { value: string; label: string }[] = [];
    for (let i = 0; i < this.data.data!.formFlows.length; i++) {
      const flow = this.data.data!.formFlows[i];
      if (
        flow.actionType === WorkFlowActionType.CC ||
        flow.actionType === WorkFlowActionType.PRESENT
      ) {
        continue;
      }
      for (const user of flow.userInfoList ?? []) {
        if (
          (!user.editAble && !!user.fileId) ||
          flow.actionType === WorkFlowActionType.FILL_IN
        ) {
          flowOpts.push({
            value: `${flow.id},${user.userId}`,
            label: `[${i}] ${WorkFlowActionTypeMap[flow.actionType!]} ${
              user.userName
              // } ${
              //   user.operateTime
              //     ? moment(new Date(user.operateTime).toISOString())
              //         .locale('zh_cn')
              //         .format('yyyy-MM-DD HH:mm:ss')
              //     : ''
            }`,
          });
        }
      }
    }
    this.flowOpts = flowOpts;

    // 退回和撤回的默认节点
    // 退回是退回到上一个节点
    // 撤回是撤回到填写
    if (this.isCancel) {
      this.selectFlow = this.flowOpts[0].value;
    } else {
      this.selectFlow = this.flowOpts[this.flowOpts.length - 1].value;
    }
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  choose(flowId: number) {
    let index = this.selected.indexOf(flowId);
    if (index > -1) {
      this.selected.splice(index, 1);
    } else {
      this.selected.push(flowId);
    }
  }

  private handleDataBeforeConfirm(
    response: WorkFlowRefectSignRequest,
  ): WorkFlowRefectSignRequest {
    const data = JSON.parse(
      JSON.stringify(response),
    ) as WorkFlowRefectSignRequest;
    data.togetherWorkFlowIds = this.selected;
    data.rejectFlowId = this.selectFlow
      ? parseInt(this.selectFlow.split(',')[0], 10)
      : 0;
    data.rejectFlowUserId = this.selectFlow
      ? parseInt(this.selectFlow.split(',')[1], 10)
      : 0;
    return data;
  }

  get canConfirm() {
    if (this.submiting || !this.record.rejectReason || this.selectFlow === '') {
      return false;
    }

    return true;
  }

  private submit() {
    this.message.info('正在' + (this.isCancel ? '撤回' : '退回') + '中...');
    this.submiting = true;

    if (this.isCancel && this.selectFlow === this.flowOpts[0].value) {
      this.workFlowUserService
        .cancleSign({
          workFlowId: this.record.workFlowId!,
          cancleReason: this.record.rejectReason,
        })
        .subscribe((response: boolean) => {
          this.submiting = false;
          this.message.success((this.isCancel ? '撤回' : '退回') + '成功');
          if (response) {
            this.data.onConfirm!();
          }
        });
    } else {
      this.workFlowUserService
        .rejectSign(this.handleDataBeforeConfirm(this.record))
        .subscribe((response: boolean) => {
          this.submiting = false;
          this.message.success((this.isCancel ? '撤回' : '退回') + '成功');
          if (response) {
            this.data.onConfirm!();
          }
        });
    }
  }
}
